@if (isSelfAuthoring()) {
  <details-section class="score-distribution" [showDetails]="false" [title]="'simulationBuilder.SCORE_DISTRIBUTION_TITLE' | transloco">
    <button
      qai-button
      headerAction
      [shape]="'normal'"
      [kind]="'tertiary'"
      [size]="'medium'"
      [disabled]="readOnly"
      (click)="editWeighting()"
    >
      {{ 'simulationBuilder.EDIT_SECTIONS_AND_WEIGHTING' | transloco }}
    </button>
    <score-distribution-chart
      [weights]="sectionWeights"
    ></score-distribution-chart>
  </details-section>
} @else {
  <details-section
    [title]="'simulationBuilder.OVERALL_SECTION_TITLE' | transloco"
    [showDetails]="false"
    description="{{ description }}"
  >
    <scoring-weights [weights]="sectionWeights"> </scoring-weights>
    <p class="overall-heading">{{ 'simulationBuilder.OVERALL_HEADING' | transloco }}</p>
    <div class="container" [formGroup]="form">
      <div [formGroup]="overallScorePromptGroup">
        <qai-field [label]="overallPromptLabel">
          <textarea
            qai-textarea
            autosize
            qaiPasteClean
            [maxLines]="30"
            qaiTrimLeading
            formControlName="promptText"
          ></textarea>
        </qai-field>
      </div>
    </div>
  </details-section>
}

<edit-weighting-modal
  [open]="openEditModal"
  [weights]="modalWeights"
  [isSelfAuthoring]="isSelfAuthoring()"
  (confirm)="handleModalConfirm($event)"
  (closeModal)="handleModalClose()"
></edit-weighting-modal>
